import { TextField, Autocomplete } from "@mui/material";

const options = ["Male", "Female"];

const SelectGender = ({ ref, ...props }) => {
  return (
    <Autocomplete
      {...props}
      ref={ref}
      options={options}
      getOptionLabel={(option) => option}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          helperText={props.helpertext}
          label={props.label || "Gender"}
          disabled={props.disabled}
        />
      )}
    />
  );
};

export default SelectGender;
